"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.array.sort");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.string.starts-with");
var _enroll = require("@/api/activity/enroll");
var _lottery = require("@/api/activity/lottery");
var _gradeInfo = require("@/api/basic/gradeInfo");
var _common = require("@/api/common");
var _shopList = require("@/api/shop/shopList");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 参与地区“全国”选项值（region_id 均为正数，0 表示全国=不限地区，保存时落地为空）
var NATIONWIDE_ZONE = 0;

// 自定义图片上传组件
var ImageUpload = {
  name: 'ImageUpload',
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      fileList: [],
      uploading: false
    };
  },
  watch: {
    value: function value(val) {
      if (val && !this.fileList.length) {
        this.fileList = [{
          name: 'image',
          url: this.getDisplayUrl(val)
        }];
      } else if (!val) {
        this.fileList = [];
      }
    }
  },
  created: function created() {
    if (this.value) {
      this.fileList = [{
        name: 'image',
        url: this.getDisplayUrl(this.value)
      }];
    }
  },
  methods: {
    getDisplayUrl: function getDisplayUrl(path) {
      if (!path) return '';
      if (path.startsWith('http://') || path.startsWith('https://')) return path;
      var prefix = process.env.VUE_APP_IMAGE_PATH || '';
      if (!prefix) return path;
      var p = prefix.endsWith('/') ? prefix : prefix + '/';
      var v = path.startsWith('/') ? path.slice(1) : path;
      return p + v;
    },
    beforeUpload: function beforeUpload(file) {
      var isImage = file.type.startsWith('image/');
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB!');
        return false;
      }
      return true;
    },
    uploadImage: function () {
      var _uploadImage = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(file) {
        var loading, res, url, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context.prev = 1;
              _context.next = 2;
              return (0, _enroll.uploadEnrollImage)(file);
            case 2:
              res = _context.sent;
              loading.close();
              url = res && res.data || res;
              if (url) {
                this.fileList = [{
                  name: file.name,
                  url: this.getDisplayUrl(url)
                }];
                this.$emit('input', url);
                this.$message.success('上传成功');
              } else {
                this.$message.error('上传失败');
                this.fileList = [];
              }
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              loading.close();
              this.$message.error('上传失败：' + _t.message);
              this.fileList = [];
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 3]]);
      }));
      function uploadImage(_x) {
        return _uploadImage.apply(this, arguments);
      }
      return uploadImage;
    }(),
    handleRemove: function handleRemove() {
      this.fileList = [];
      this.$emit('input', '');
    },
    handlePreview: function handlePreview() {
      if (this.fileList.length > 0) {
        window.open(this.fileList[0].url, '_blank');
      }
    }
  },
  render: function render(h) {
    var _this = this;
    var hasFile = this.fileList.length > 0;
    if (hasFile && !this.disabled) {
      return h('div', {
        class: 'image-upload-container',
        style: {
          position: 'relative',
          display: 'inline-block',
          width: '100px',
          height: '100px'
        }
      }, [h('img', {
        attrs: {
          src: this.fileList[0].url
        },
        style: {
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          borderRadius: '6px',
          border: '1px solid #dcdfe6'
        },
        on: {
          click: this.handlePreview
        }
      }), h('i', {
        class: 'el-icon-close',
        style: {
          position: 'absolute',
          top: '-8px',
          right: '-8px',
          width: '20px',
          height: '20px',
          borderRadius: '50%',
          backgroundColor: '#909399',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          fontSize: '12px',
          zIndex: 1
        },
        on: {
          click: this.handleRemove
        }
      })]);
    } else {
      var uploadButton = h('el-upload', {
        class: 'image-uploader',
        props: {
          'show-file-list': false,
          'before-upload': this.beforeUpload,
          'http-request': function httpRequest(options) {
            _this.uploadImage(options.file);
          },
          disabled: this.disabled
        }
      }, [h('div', {
        class: 'el-upload el-upload--text',
        style: {
          width: '100px',
          height: '100px',
          border: '1px dashed #d9d9d9',
          borderRadius: '6px',
          cursor: this.disabled ? 'not-allowed' : 'pointer',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#fbfdff'
        }
      }, [h('i', {
        class: 'el-icon-plus',
        style: {
          fontSize: '28px',
          color: '#8c939d'
        }
      })])]);
      return h('div', {
        class: 'image-upload-container',
        style: {
          display: 'inline-block'
        }
      }, [uploadButton]);
    }
  }
};
var _default = exports.default = {
  name: 'EnrollConfigPane',
  components: {
    ImageUpload: ImageUpload
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      loading: false,
      timeRange: [],
      gradeOptions: [],
      tagOptions: [],
      cityOptions: [],
      hasDetailLevels: false,
      bonusList: [],
      userLevelsChecked: [],
      userTagsChecked: [],
      zoneChecked: [NATIONWIDE_ZONE],
      rewardItems: [],
      originalStock: null,
      form: {
        title: '',
        title2: '',
        userLevels: '',
        userTags: '',
        userWw: 0,
        rule: '',
        startTime: null,
        endTime: null,
        drawTime: null,
        isEnable: 1,
        imgUrl: '',
        gzImgUrl: '',
        drawImgUrl: '',
        zone: '',
        input1: '',
        input2: '',
        input3: '',
        points: 0,
        stock: 0,
        startNoticeSqtitle: '',
        startNoticeUser: 0,
        startNoticeSms: 0,
        startNoticeWxsms: 0,
        startNoticeSmsTemplateId: '',
        startNoticeWxTemplateId: '',
        drawNoticeSqtitle: '',
        drawNoticeUser: 0,
        drawNoticeSms: 0,
        drawNoticeWxsms: 0,
        drawNoticeSmsTemplateId: '',
        drawNoticeWxTemplateId: ''
      },
      rules: {
        title: [{
          required: true,
          message: '请输入大标题',
          trigger: 'blur'
        }],
        drawTime: [{
          required: true,
          message: '请选择开奖时间',
          trigger: 'change'
        }]
      }
    };
  },
  computed: {
    isEdit: function isEdit() {
      return !!this.id;
    },
    isLevelIndeterminate: function isLevelIndeterminate() {
      return this.userLevelsChecked.length > 0 && this.userLevelsChecked.length < this.gradeOptions.length;
    },
    isLevelAllChecked: function isLevelAllChecked() {
      return this.gradeOptions.length > 0 && this.userLevelsChecked.length === this.gradeOptions.length;
    },
    isNationwide: function isNationwide() {
      return this.zoneChecked.indexOf(NATIONWIDE_ZONE) !== -1;
    }
  },
  created: function created() {
    this.loadGradeOptions();
    this.loadTagOptions();
    this.loadCityOptions();
    this.loadBonusList();
    if (this.id) {
      this.fetchDetail();
    }
  },
  methods: {
    fetchDetail: function fetchDetail() {
      var _this2 = this;
      this.loading = true;
      (0, _enroll.getEnrollDetail)(this.id).then(function (response) {
        var data = response.data;
        Object.keys(_this2.form).forEach(function (key) {
          if (data[key] !== undefined && data[key] !== null) {
            _this2.form[key] = data[key];
          }
        });
        _this2.originalStock = data.stock;
        if (data.startTime && data.endTime) {
          _this2.timeRange = [data.startTime, data.endTime];
        }
        if (data.userLevels) {
          _this2.hasDetailLevels = true;
          _this2.userLevelsChecked = data.userLevels.split(',').filter(Boolean).map(Number);
        }
        if (data.userTags) {
          _this2.userTagsChecked = data.userTags.split(',').filter(Boolean).map(Number);
        }
        if (data.zone) {
          _this2.zoneChecked = data.zone.split(',').filter(Boolean).map(Number);
        } else {
          // 未配置地区 = 全国
          _this2.zoneChecked = [NATIONWIDE_ZONE];
        }

        // 奖品明细
        var items = data.items || [];
        _this2.rewardItems = items.map(function (i) {
          return {
            typeId: i.typeId,
            num: i.num || 1
          };
        });
        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    },
    loadGradeOptions: function () {
      var _loadGradeOptions = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return (0, _gradeInfo.xyRuleVipGradeSelPage)({
                page: 1,
                limit: 100
              });
            case 1:
              response = _context2.sent;
              if (response.code === 200 && response.records) {
                this.gradeOptions = response.records.map(function (item) {
                  return {
                    id: item.id,
                    name: item.name
                  };
                });
                // 初始默认全选（编辑时已保存过等级则以保存值为准）
                if (!this.hasDetailLevels) {
                  this.userLevelsChecked = this.gradeOptions.map(function (grade) {
                    return grade.id;
                  });
                }
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              console.error('获取会员等级列表失败:', _t2);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function loadGradeOptions() {
        return _loadGradeOptions.apply(this, arguments);
      }
      return loadGradeOptions;
    }(),
    loadTagOptions: function () {
      var _loadTagOptions = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response, list, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 1;
              return (0, _common.getMemberLabelCombo)();
            case 1:
              response = _context3.sent;
              list = response && response.data || response || []; // 数据来源 xy_users_label（label_id / label_name）
              this.tagOptions = (Array.isArray(list) ? list : []).map(function (item) {
                return {
                  id: item.labelId,
                  name: item.labelName
                };
              });
              _context3.next = 3;
              break;
            case 2:
              _context3.prev = 2;
              _t3 = _context3["catch"](0);
              console.error('获取用户标签列表失败:', _t3);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function loadTagOptions() {
        return _loadTagOptions.apply(this, arguments);
      }
      return loadTagOptions;
    }(),
    loadCityOptions: function () {
      var _loadCityOptions = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var response, list, _t4;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 1;
              return (0, _shopList.getEffectiveCityList)({
                regionType: 2
              });
            case 1:
              response = _context4.sent;
              list = response && response.data || response || [];
              this.cityOptions = (Array.isArray(list) ? list : []).map(function (item) {
                return {
                  regionId: item.regionId !== undefined ? item.regionId : item.id,
                  regionName: item.regionName || item.name
                };
              });
              _context4.next = 3;
              break;
            case 2:
              _context4.prev = 2;
              _t4 = _context4["catch"](0);
              console.error('获取地区列表失败:', _t4);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function loadCityOptions() {
        return _loadCityOptions.apply(this, arguments);
      }
      return loadCityOptions;
    }(),
    loadBonusList: function () {
      var _loadBonusList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var response, _t5;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 1;
              return (0, _lottery.getBonusList)();
            case 1:
              response = _context5.sent;
              if (response.code === 200 && response.data) {
                this.bonusList = response.data;
              }
              _context5.next = 3;
              break;
            case 2:
              _context5.prev = 2;
              _t5 = _context5["catch"](0);
              console.error('加载优惠券列表失败:', _t5);
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function loadBonusList() {
        return _loadBonusList.apply(this, arguments);
      }
      return loadBonusList;
    }(),
    addRewardItem: function addRewardItem() {
      this.rewardItems.push({
        typeId: null,
        num: 1
      });
    },
    removeRewardItem: function removeRewardItem(index) {
      this.rewardItems.splice(index, 1);
    },
    handleCheckAllLevel: function handleCheckAllLevel(val) {
      this.userLevelsChecked = val ? this.gradeOptions.map(function (grade) {
        return grade.id;
      }) : [];
    },
    handleZoneChange: function handleZoneChange(val) {
      // 选择全国后，其他地区不需要且不可再选，之前选的全部清空
      if (val.indexOf(NATIONWIDE_ZONE) !== -1) {
        this.zoneChecked = [NATIONWIDE_ZONE];
      }
    },
    handleSubmit: function handleSubmit() {
      var _this3 = this;
      this.$refs.formRef.validate(/*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(valid) {
          var validItems, formData, _t6;
          return regeneratorRuntime.wrap(function (_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                if (valid) {
                  _context6.next = 1;
                  break;
                }
                return _context6.abrupt("return");
              case 1:
                if (!(!_this3.timeRange || _this3.timeRange.length !== 2)) {
                  _context6.next = 2;
                  break;
                }
                _this3.$message.error('请选择活动时间');
                return _context6.abrupt("return");
              case 2:
                if (!(_this3.form.drawTime && _this3.timeRange[1] && _this3.form.drawTime <= _this3.timeRange[1])) {
                  _context6.next = 3;
                  break;
                }
                _this3.$message.error('开奖时间需晚于活动结束时间');
                return _context6.abrupt("return");
              case 3:
                // 过滤未选择优惠券的空行
                validItems = _this3.rewardItems.filter(function (i) {
                  return i.typeId;
                });
                if (!(validItems.length === 0)) {
                  _context6.next = 4;
                  break;
                }
                _this3.$message.error('请至少配置一条中奖奖品');
                return _context6.abrupt("return");
              case 4:
                if (!_this3.isEdit) {
                  _context6.next = 5;
                  break;
                }
                if (!(_this3.form.stock != null && _this3.originalStock != null && _this3.form.stock < _this3.originalStock)) {
                  _context6.next = 5;
                  break;
                }
                _this3.$message.error('奖励数量只能增加不能减少');
                return _context6.abrupt("return");
              case 5:
                if (!(_this3.form.startNoticeSms === 1 && !_this3.form.startNoticeSmsTemplateId)) {
                  _context6.next = 6;
                  break;
                }
                _this3.$message.error('开始通知开启发送短信时请输入短信模版ID');
                return _context6.abrupt("return");
              case 6:
                if (!(_this3.form.startNoticeWxsms === 1 && !_this3.form.startNoticeWxTemplateId)) {
                  _context6.next = 7;
                  break;
                }
                _this3.$message.error('开始通知开启微信订阅消息时请输入微信模版ID');
                return _context6.abrupt("return");
              case 7:
                if (!(_this3.form.drawNoticeSms === 1 && !_this3.form.drawNoticeSmsTemplateId)) {
                  _context6.next = 8;
                  break;
                }
                _this3.$message.error('开奖通知开启发送短信时请输入短信模版ID');
                return _context6.abrupt("return");
              case 8:
                if (!(_this3.form.drawNoticeWxsms === 1 && !_this3.form.drawNoticeWxTemplateId)) {
                  _context6.next = 9;
                  break;
                }
                _this3.$message.error('开奖通知开启微信订阅消息时请输入微信模版ID');
                return _context6.abrupt("return");
              case 9:
                formData = _objectSpread({}, _this3.form);
                formData.startTime = _this3.timeRange[0];
                formData.endTime = _this3.timeRange[1];

                // 资格限制：逗号分隔，空=不限
                formData.userLevels = (0, _toConsumableArray2.default)(_this3.userLevelsChecked).sort(function (a, b) {
                  return a - b;
                }).join(',');
                formData.userTags = (0, _toConsumableArray2.default)(_this3.userTagsChecked).sort(function (a, b) {
                  return a - b;
                }).join(',');
                formData.zone = (0, _toConsumableArray2.default)(_this3.zoneChecked).filter(function (v) {
                  return v !== NATIONWIDE_ZONE;
                }).sort(function (a, b) {
                  return a - b;
                }).join(',');

                // 组装奖品明细
                formData.items = validItems.map(function (i) {
                  return {
                    typeId: i.typeId,
                    num: i.num
                  };
                });
                if (_this3.id) {
                  formData.id = _this3.id;
                }
                _this3.loading = true;
                _context6.prev = 10;
                _context6.next = 11;
                return (0, _enroll.saveEnroll)(formData);
              case 11:
                _this3.$message.success('保存成功');
                _this3.$emit('success');
                _context6.next = 13;
                break;
              case 12:
                _context6.prev = 12;
                _t6 = _context6["catch"](10);
                console.error('保存失败:', _t6);
              case 13:
                _context6.prev = 13;
                _this3.loading = false;
                return _context6.finish(13);
              case 14:
              case "end":
                return _context6.stop();
            }
          }, _callee6, null, [[10, 12, 13, 14]]);
        }));
        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    handleCancel: function handleCancel() {
      this.$emit('cancel');
    }
  }
};